import type { Member } from "../types";
import { SparkleIcon, UserIcon } from "./Icons";

export function MemberPicker({ members, onSelect }: { members: Member[]; onSelect: (id: string) => void }) {
  return (
    <main className="welcome-shell">
      <section className="welcome-card member-picker">
        <div className="brand-mark"><SparkleIcon /></div>
        <p className="eyebrow">WELCOME HOME</p>
        <h1>今日はどちらですか？</h1>
        <p className="welcome-copy">この端末で記録する人を選んでください。選択は端末に保存されます。</p>
        <div className="member-options">
          {members.map((member, index) => (
            <button key={member.id} className={`member-option member-${index + 1}`} onClick={() => onSelect(member.id)}>
              <span className="member-avatar"><UserIcon /></span>
              <span>{member.name}</span>
            </button>
          ))}
        </div>
      </section>
    </main>
  );
}
